import React from 'react';
import { Page, Toolbar, Tab, Link, Tabs, Icon } from 'framework7-react';
import { } from 'framework7-icons';
import HomeTab from "../pages/HomeTab";
import SearchTab from "../pages/SearchTab";
import BidsTab from "../pages/BidsTab";
import OrdersTab from "../pages/OrdersTab";
import ProfileTab from "../pages/ProfileTab";
import { useEffect , useState} from 'react';
import axios from 'axios';
import { API_BASE_URL, API_AUTH , IMG_URL } from './../globals';
// import OTPTab from "./pages/OtpVerification";

const TabMain = () => {
  // const [isBottom, setIsBottom] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [auth, setAuth] = useState(localStorage.getItem('auth'));
  useEffect(()=>{
    setIsMobile(window.innerWidth <= 1024);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);

    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };


    

  },[])
  useEffect(()=>{
    const id = localStorage.getItem('id');
    const token = localStorage.getItem('token');
    const headers = {
      'Authorization': 'Basic ' + API_AUTH
    };
    axios.post(API_BASE_URL + 'custauth', { id, token }, { headers })
      .then(response => {
        console.log(response.data);
        if (response.data.status === "success") {
          localStorage.setItem('auth', true);
          setAuth(true);
          // Introduce a delay of 1000 milliseconds (1 second) after API call success
          // setTimeout(() => {
          //   setIsLoading(false); // API call is complete
          //   f7.views.main.router.navigate('/main/');
          // }, 1000);
        } else {
          localStorage.setItem('auth', false);
          setAuth(false);
          // // Introduce a delay of 1000 milliseconds (1 second) after API call failure
          // setTimeout(() => {
          //   setIsLoading(false); // API call is complete
          //   // f7.views.main.router.navigate('/login/');
          // }, 1000);
        }
      })
      .catch(error => {
        setAuth(false);
        // Introduce a delay of 1000 milliseconds (1 second) after API call error
        // setTimeout(() => {
        //   setIsLoading(false); // API call is complete even in case of an error
        //   console.log(error);
        //   // f7.views.main.router.navigate('/login/');
        // }, 1000);
      });
  })
  return (
  <Page className='bg-white'>
      <Toolbar tabbar noShadow bottom className={isMobile ? "navbar-menu ":" navbar-menu-left appBottomMenu" }>
        <Link
          tabLink="#tab-1"
          text="HOME"
          tabLinkActive
          className="text-1 active"
          iconIos="material:home"
          iconAurora="material:home"
          iconMd="material:home"
        ></Link>
        <Link
          tabLink="#tab-2"
          text="BROWSE"      
          className="text-1" 
          iconIos="material:search"
          iconAurora="material:search"
          iconMd="material:search"     
        ></Link>
        <Link
          tabLink="#tab-3"
          text="EVENT"      
          className="text-1"
          iconIos="material:date_range"
          iconAurora="material:date_range"
          iconMd="material:date_range"           
        ></Link>
        <Link
          tabLink="#tab-5"
          text="ACCOUNT" 
          className="text-1"
          iconIos="material:person_outline"
          iconAurora="material:person_outline"
          iconMd="material:person_outline"
        ></Link>
      </Toolbar>
      <Tabs>
        <Tab id="tab-1" tabActive>
          <HomeTab />          
        </Tab>
        <Tab id="tab-2">
          <SearchTab />          
        </Tab>
        <Tab id="tab-3">
    
          <BidsTab /> 
                
        </Tab>
        <Tab id="tab-4">
          <OrdersTab />          
        </Tab>
        <Tab id="tab-5">

            <ProfileTab />          

          
        </Tab>
      </Tabs>
    </Page>
  );
};

export default TabMain;